var map = {
	"./404.svg": 4235,
	"./bug.svg": 2813,
	"./chart.svg": 6132,
	"./clipboard.svg": 6889,
	"./component.svg": 250,
	"./dashboard.svg": 4679,
	"./documentation.svg": 3397,
	"./drag.svg": 8715,
	"./edit.svg": 5869,
	"./education.svg": 3937,
	"./email.svg": 9083,
	"./example.svg": 1649,
	"./excel.svg": 2474,
	"./exit-fullscreen.svg": 4861,
	"./eye-open.svg": 2429,
	"./eye.svg": 5628,
	"./form.svg": 3771,
	"./fullscreen.svg": 6638,
	"./guide.svg": 7987,
	"./icon.svg": 2814,
	"./international.svg": 5091,
	"./language.svg": 5247,
	"./link.svg": 1445,
	"./list.svg": 9161,
	"./lock.svg": 2636,
	"./message.svg": 8166,
	"./money.svg": 9659,
	"./nested.svg": 5016,
	"./password.svg": 9902,
	"./pdf.svg": 8001,
	"./people.svg": 4952,
	"./peoples.svg": 6779,
	"./qq.svg": 5951,
	"./search.svg": 8217,
	"./shopping.svg": 5697,
	"./size.svg": 8334,
	"./skill.svg": 2160,
	"./star.svg": 8637,
	"./tab.svg": 4598,
	"./table.svg": 4383,
	"./theme.svg": 8972,
	"./tree-table.svg": 1622,
	"./tree.svg": 2701,
	"./user.svg": 8848,
	"./wechat.svg": 719,
	"./zip.svg": 1902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;